import { BulkActions } from '@common/components/Actions/BulkActions';
import { Flex } from '@radix-ui/themes';
import { Clip } from '..';
import { useClipActions } from '../hooks/useClipActions';

interface ActionsBlockProps {
    selectedClip: Clip;
}

export const ActionsBlock = ({ selectedClip }: ActionsBlockProps) => {
    const { baseActions, ClipActionModals } = useClipActions();

    return (
        <Flex gap={'2'}>
            <BulkActions
                actions={baseActions}
                selectedItems={[selectedClip]}
                size={'3'}
            />

            <ClipActionModals />
        </Flex>
    );
};
